import { Modal, Button, Text, NumberEasing, Icon, Chip } from '@/components'
import { isDecimal } from '@/utils/number'
import { ThermostatCostSavingsViewModel } from './useThermostatCostSavingsViewModel'
import { useState, useMemo } from 'react'

export interface Props {
  viewModel: ThermostatCostSavingsViewModel
}

export default function ThermostatSavingsCalculationModal(props: Props) {
  const { viewModel } = props
  const [isModalOpen, setIsModalOpen] = useState(false)

  const savingsDecimals = isDecimal(viewModel.savingsAmount) ? 2 : 0

  // Modal content text
  const modalContentText = useMemo(() => {
    const periodText =
      viewModel.period === 'day'
        ? 'Today'
        : `Over the last ${viewModel.periodDays} days`
    const timeText = viewModel.adjustmentCount !== 1 ? 'times' : 'time'

    return `${periodText} we adjusted your thermostat ${viewModel.adjustmentCount} ${timeText} by changing your temperature to reduce the amount of time your HVAC ran. These adjustments saved you a total of:`
  }, [viewModel.period, viewModel.periodDays, viewModel.adjustmentCount])

  return (
    <Modal
      title="How are savings calculated?"
      id="savings-calculation-modal"
      open={isModalOpen}
      onOpen={() => setIsModalOpen(true)}
      onClose={() => setIsModalOpen(false)}
    >
      <Modal.Activator>
        <Icon
          name="Info"
          size={16}
          className="text-themed-grey-400 cursor-pointer"
          aria-label="How are savings calculated?"
        />
      </Modal.Activator>
      <Text variant="body2" className="mb-4">
        {modalContentText}
      </Text>
      <Chip className="bg-themed-green-100 py-1 px-3 rounded-lg w-fit">
        <Text className="text-themed-green-700">
          +$
          <NumberEasing
            value={viewModel.savingsAmount}
            decimals={savingsDecimals}
            speed={400}
            ease="quintOut"
          />
        </Text>
      </Chip>
      <Modal.Actions>
        <Button
          id="savings-modal-close-button"
          onClick={() => setIsModalOpen(false)}
          variant="primary"
        >
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
